import * as Yup from 'yup';
import { formikRequired } from '../SoftwareList/validator';

const Validator = () =>
  Yup.object().shape({
    note: formikRequired,
  });

export default Validator;
